module.exports = __webpack_public_path__ + "static/media/WhiteUpArrow.8ac02284.svg";